'use client';

import { ConnectButton } from '@rainbow-me/rainbowkit';
import { ChevronIcon, DropdownButton } from 'mode-shared/components';
import Image from 'next/image';

export const ChainDropdown = () => {
  return (
    <ConnectButton.Custom>
      {({ openChainModal, chain }) => {
        if (!chain) return null;

        return (
          <DropdownButton onClick={openChainModal}>
            <div className="flex items-center gap-x-2">
              {chain.hasIcon && (
                <div className="rounded-full h-6 w-6 shrink-0 overflow-hidden">
                  {chain.iconUrl && (
                    <Image alt={chain.name ?? 'Chain icon'} src={chain.iconUrl} width={24} height={24} />
                  )}
                </div>
              )}
              <p className="hidden md:flex items-center text-xs font-medium text-neutral-100">
                {chain.name}
                <ChevronIcon />
              </p>
            </div>
          </DropdownButton>
        );
      }}
    </ConnectButton.Custom>
  );
};
